import { ISurveyResponse } from './interfaces/ISurveyResponse';

class SurveyUtils {
  static getPathByType(type: string) {
    switch (type) {
      case 'BAROMETER':
        return 'b';
      case 'NPS':
        return 'n';
      case 'STANDARD':
        return 's';
      case 'CUSTOMSURVEY':
        return 'c';
      default:
        return '';
    }
  }

  static getEndpointByType(type: string | undefined) {
    switch (type) {
      case 'BAROMETER':
        return 'trend';
      case 'NPS':
        return 'nps';
      case 'STANDARD':
        return 'standard';
      case 'CUSTOMSURVEY':
        return 'customsurvey';
      default:
        return '';
    }
  }

  static getName(name: string | undefined) {
    if (name === 'GooglePlace') {
      return 'Google';
    }
    return name;
  }

  static isCompleted(answers: any[], questions: ISurveyResponse[]) {
    console.log('Iscompleted', answers, questions);
    let oneIsGood = false;
    for (const question of questions) {
      if (false == question.optional) {
        const answer = answers.find((answer: any) => answer.questionId == question.id);
        if (!answer) {
          return false;
        }
      }
      oneIsGood = true;
    }
    return oneIsGood;
  }

  static evaluateCustom(surveyResponses: ISurveyResponse[]) {
    let total = 0;
    let completed = 0;
    let abborted = 0;

    const customResponses: any = {};

    surveyResponses.sort((a, b) => (a.position || 0) - (b.position || 0));

    surveyResponses.forEach((question, index) => {
      question.answers.forEach((answer) => {
        const responseId = answer.responseId || answer.createdAt;
        if (!customResponses[responseId]) {
          customResponses[responseId] = [];
        }
        answer.questionId = question.id;
        customResponses[responseId].push(answer);
      });
    });
    const responseIds = Object.keys(customResponses);
    total = responseIds.length;
    responseIds.forEach((rid: string) => {
      if (this.isCompleted(customResponses[rid], surveyResponses)) {
        completed++;
      } else {
        abborted++;
      }
    });
    return {
      total: total,
      completed: completed,
      abborted: abborted,
      responses: customResponses,
      sorted: surveyResponses,
    };
  }

  static getTypeName(type: string, t: any) {
    switch (type) {
      case 'NPS':
        return t('nps_survey');
      case 'STANDARD':
        return t('survey');
      case 'CUSTOMSURVEY':
        return t('custom_survey');
      case 'BAROMETER':
        return t('mood_barometer');
      default:
        return '';
    }
  }
}

export default SurveyUtils;
